import { asFunction } from "@/_di/resolvers";
import { VisitUseCases, visitUseCases } from "@/core/visit/useCases/visitUseCases";
import { apiVisitRepository } from "@/core/visit/infraestructure/apiVisitRepository";
import { VisitRepository } from "@/core/visit/domain/visitRepository";
export const visitModule = {
  visitUseCases: asFunction<VisitUseCases>(visitUseCases),
  visitRepository: asFunction<VisitRepository>(apiVisitRepository),
};
